import axios, { AxiosError } from "axios";

import { AnsweredQuestionWithId } from "@teamprevent/common/questionnaires/model";
import { TaskModel } from "@teamprevent/common/task/taskActions/models";

import { parseTaskModel } from "../task/model";

import { PhysiotherapyAssessmentConsultationTemplate } from "./models";

const buildUrl = (customerId: string, ohCaseId: string, taskId: string) =>
    `/api/${customerId}/ohCase/${ohCaseId}/task/${taskId}/physiotherapyAssessmentConsultationClinicalNotes`;

const saveClinicalNotes = async (customerId: string, ohCaseId: string, taskId: string, questions: AnsweredQuestionWithId[], eTag: string) => {
    try {
        const response = await axios.post(buildUrl(customerId, ohCaseId, taskId), { data: { questions }, eTag });
        return response?.data;
    } catch (ex) {
        const axiosError = ex as AxiosError;
        if (axiosError.response?.status === 400) {
            const error = { message: "Could not save as a newer version exists", status: 400 };
            throw error;
        } else {
            throw ex;
        }
    }
};

const submitClinicalNotes = async (customerId: string, ohCaseId: string, taskId: string) => {
    const response = await axios.post<TaskModel[]>(`${buildUrl(customerId, ohCaseId, taskId)}/complete`);
    return response.data.map(parseTaskModel);
};

const getTemplate = async (customerId: string, ohCaseId: string, taskId: string) => {
    const response = await axios.get<PhysiotherapyAssessmentConsultationTemplate>(`${buildUrl(customerId, ohCaseId, taskId)}/template`);
    return response.data;
};

const getUnmatched = async (customerId: string, physiotherapyReferralId: string) => {
    const response = await axios.get(`/api/physiotherapy/${customerId}/${physiotherapyReferralId}`);
    return response.data;
};

export const physiotherapyReferralApi = {
    saveClinicalNotes,
    submitClinicalNotes,
    getTemplate,
    getUnmatched
};
